// extracted by mini-css-extract-plugin
export default {"container":"Vq-z","heading":"Wq-z","text":"Xq-z","info":"Yq-z","link":"Zq-z","fullMaxWidth":"_q-z"};